<template lang="pug">
  .profile-page__content

    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Текстовое описание

      .profile-section__body
        .form
          .form__elem.form__elem_full
            .form-elem.form-elem_horizontal
              textarea.textarea.textarea_full(
                rows="10"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Ссылка на видео
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value=""
                )

    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Фотографии базы отдыха

      .profile-section__body
        .form
          .form__elem.form__elem_full
            .photo-upload
              .photo-upload__text Размер фото не больше 3мб
              .photo-upload__container
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/1.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/2.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/3.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/4.jpg")
                .photo-upload__img
                  img(src="@/assets/images/photo-upload-test/5.jpg")
                //.photo-upload__img
                  img(src="@/assets/images/photo-upload-test/6.jpg")
                .photo-upload__button.button.button_paint-main--light
                  .button__icon
                    img(src="@/assets/images/icons/clip.svg")
                  .button__text Добавить файл

    section.form__elem.form__elem--align-right.form__elem_full
      button.button.button_paint-main.button_long
        .button__text Сохранить
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "OperatorCampAbout",
  components: {
    Multiselect
  },
  data() {
    return {
      value: [
        {name: "ДОЛ Лето", code: "camp"},
        {name: "ДОЛ Лето 2", code: "camp2"}
      ],
      options: [
        {name: "ДОЛ Лето", code: "camp"},
        {name: "ДОЛ Лето 2", code: "camp2"},
        {name: "Для детей от 7 до 10", code: "7-10"},
        {name: "Для детей от 10 до 14", code: "10-14"},
        {name: "Спорт", code: "sport"},
        {name: "Компьютеры", code: "computers"}
      ],
      campTypeList: [
        {
          text: "Палаточный",
          value: true
        },
        {
          text: "Стационарный",
          value: false
        }
      ],
      operatorPageData: {
        title: "О лагере",
        description: ""
        // "Здесь вы можете изменить данные своего профиля, следить за статусом заявки, а так же загрузить все необходимы для подачи заявки документы и информацию о детях"
      }
    };
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      };
      this.options.push(tag);
      this.value.push(tag);
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
